var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7929 3.79288C17.0119 2.57392 18.9882 2.57392 20.2071 3.79288C21.4261 5.01183 21.4261 6.98813 20.2071 8.20709L13.0988 15.3154C12.7144 15.6999 12.2326 15.9726 11.7051 16.1045L8.24256 16.9701C7.90178 17.0553 7.54129 16.9555 7.29291 16.7071C7.04453 16.4587 6.94468 16.0982 7.02988 15.7574L7.89552 12.2949C8.0274 11.7674 8.30015 11.2856 8.68463 10.9012L15.7929 3.79288ZM18.7929 5.20709C18.355 4.76919 17.645 4.76919 17.2071 5.20709L10.0988 12.3154C9.97068 12.4435 9.87976 12.6041 9.83581 12.7799L9.37439 14.6256L11.2201 14.1642C11.3959 14.1202 11.5565 14.0293 11.6846 13.9012L18.7929 6.79287C19.2308 6.35497 19.2308 5.64499 18.7929 5.20709Z",
    fill: "#4296FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 4.23858 4.23858 2 7 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7Z",
    fill: "#152C70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.71ba17378ec39adaeb3517c9f54246cd.svg";
export { ForwardRef as ReactComponent };